"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorNotification = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
function useErrorNotification(_a) {
    var Component = _a.Component, props = tslib_1.__rest(_a, ["Component"]);
    var _b = tslib_1.__read(react_1.useState(undefined), 2), errorNotification = _b[0], setErrorNotification = _b[1];
    return {
        errorNotification: (react_1.default.createElement(react_1.default.Fragment, null, errorNotification && (react_1.default.createElement(Component, tslib_1.__assign({}, props, { children: errorNotification, onClose: function () { return setErrorNotification(undefined); } }))))),
        setErrorNotification: setErrorNotification,
    };
}
exports.useErrorNotification = useErrorNotification;
//# sourceMappingURL=ErrorNotification.js.map